import React, { useEffect, useRef, useState } from "react";
import ViewBookSet from "../../../BookModule.module.css";
import styles from "../IndividualBook/ViewIndividualBook.module.css";
import { Link, useNavigate, useLocation, useParams } from "react-router-dom";
import { Download, Search } from "@mui/icons-material";
import Chip from "@mui/material/Chip";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import { AxiosInstance } from "../../../../../../../axios";
import { R_PER_PAGE } from "../../../../../../../labels";
import ViewIcon from "../../BookTabs/ViewIcon.png";
import Pagination from "../../../../../../ReusuableComponent/Pagination/Pagination";
import Loader from "../../../../../Loader";
import { ImageUrlPrefix } from "../../../../../../../labels";
import { Rating } from "@mui/material";
import moment from "moment";
import { Star } from "@mui/icons-material";
import avatarImg from "../../../ViewBook/avatarimg.png";
import { useDispatch, useSelector } from "react-redux";
import {
  clearBookFilters,
  setBookFilters,
  setFilters,
} from "../../../../../../../redux/purchaseBookFilterSlice";
export default function ViewPreOrder() {
  const navigate = useNavigate();
  const { ID, bookID } = useParams();
  const location = useLocation();
  const {
    USERNUMBER,
    USEREMAIL,
    FREESALES,
    ITEM,
    CHECKBOX,
    SELECTEDBOKS,
    BOOKITEMS,
    LABEL,
    REDUXKEY,
    BOOKIDS, IDS,
    filauthor, filpublisher, filvisibleToUser, filcategory, filcourse, filsubject, filmedium, filprice
  } = location.state ? location.state : {};


  //  data load table
  let page = R_PER_PAGE;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  let filterAvalible_to_user = [];
  let filtervisible_to_user = [];
  let filterCategory = [];
  let filterCourse = [];
  let filterSubject = [];
  let filterMedium = [];
  let filterAuthor = [];
  let filterPublisher = [];

  const filterRef_avaliable_to_user = useRef(null);
  const filterRef_category = useRef(null);
  const filterRef_course = useRef(null);
  const filterRef_subject = useRef(null);
  const filterRef_medium = useRef(null);
  const filterRef_author = useRef(null);
  const filterRef_publisher = useRef(null);
  const filterRef_visible_to_user = useRef(null);
  const txtBSearch = useRef(null); //search icon
  const txtBSearch_course = useRef(null); //search icon
  const txtBSearch_sub = useRef(null);
  const filterRef_mrp = useRef(null);
  // use state
  const [isLoading, setIsLoading] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(page);
  const [currentPage, setCurrentPage] = useState(1);

  const [updateChipData, setUpdateChipData] = useState([]);
  const [updateListData, setUpdateListData] = useState([]);

  const [sortOrder, setSortOrder] = useState("asc");
  const [sortColumn, setSortColumn] = useState("");
  const [categoryId, setCategoryId] = useState([]);
  const [courseId, setCourseId] = useState([]);
  const [originalListDataPub, setOriginalListDataPub] = useState();
  const [subjectId, setSubjectId] = useState([]);
  const [courseIds, setCourseIds] = useState([]);
  const [subjectIds, setSubjectIds] = useState([]);
  const [category_on, setCategory_on] = useState([]);
  const [course_on, setCourse_on] = useState([]);
  const [subject_on, setSubject_on] = useState([]);
  const [medium_on, setMedium_on] = useState([]);
  const [auData, setAuData] = useState([]);
  const [pubData, setPubData] = useState([]);
  const [author_name, setAuthor_name] = useState([]);
  const [publisher_name, setPublisher_name] = useState([]);
  const [visible_to_user, setVisible_to_user] = useState([]);
  const [ratingReview, setRatingView] = useState();
  const [isOpen, setIsOpen] = useState({
    category: false,
    course: false,
    subject: false,
    medium: false,
    author: false,
    publisher: false,
    visible_to_user: false,
    price: false,
  });
  const [initialfields, setInitialfields] = useState({
    fromDate: "",
    toDate: "",
  });
  const [dataView, setDataView] = useState({
    book_title: "",
    author: "",
    publisher: "",
    phoneNumber: "",
    isbn_no: "",
    price: "",
    offer_percentage: "",
    finalPrice: "",
    description: "",
    stock_count: "",
    category_name: "",
    group_course_name: "",
    subject_name: "",
    medium: "",
    is_visible: "",
    tags: "",
    weight: "",
    total_pages: "",
    iframe: "",
    dimension: "",
    preview_path: "",
    original_preview_path: "",
    tag_line: "",
    is_free_book: "",
    is_combo_offer: "",
  });
  const handleChange = (event) => {
    let { name, value } = event.target;
    setInitialfields((prevFields) => ({
      ...prevFields,
      [name]: value,
    }));
  };
  const ListItem = styled("li")(({ theme }) => ({
    margin: theme.spacing(0.5),
  }));

  useEffect(() => {
    const handleClickOutside = (event) => {
      const isCheckbox = event.target.closest('input[type="checkbox"]');
      const isApplyFilterButton = event.target.closest(".filterBoxs_testlist");
      const isChipData = event.target.closest(".paperil_global");
      if (isCheckbox || isApplyFilterButton || isChipData) return;
      if (
        filterRef_author.current &&
        !filterRef_author.current.contains(event.target)
      ) {
        {
          const hasAuthor = updateChipData.some(
            (chipItem) => chipItem.type === "author"
          );
          if (hasAuthor) {
            const updatedAuthor = updateChipData.filter(
              (chipItem) => chipItem.type === "author"
            );
            setAuthor_name(updatedAuthor);
          } else {
            setAuthor_name([]);
          }
          setIsOpen((prev) => ({ ...prev, author: false }));
        }
      }
      if (
        filterRef_mrp.current &&
        !filterRef_mrp.current.contains(event.target)
      ) {
        {
          const hasAuthor = updateChipData.some(
            (chipItem) => chipItem.type === "price"
          );
          if (hasAuthor) {
            const updatedAuthor = updateChipData.filter(
              (chipItem) => chipItem.type === "price"
            );
            // alert("1")
            const [fromDate, toDate] = updatedAuthor[0].name
              .split(" - ")
              .map((val) => val.trim());

            setInitialfields({ fromDate, toDate });
          } else {
            // alert("2")

            setInitialfields({ fromDate: "", toDate: "" });
          }
          setIsOpen((prev) => ({ ...prev, price: false }));
        }
      }
      if (
        filterRef_publisher.current &&
        !filterRef_publisher.current.contains(event.target)
      ) {
        {
          const hasCategory = updateChipData.some(
            (chipItem) => chipItem.type === "publisher"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData.filter(
              (chipItem) => chipItem.type === "publisher"
            );
            setPublisher_name(updatedCategory);
          } else {
            setPublisher_name([]);
          }
          setIsOpen((prev) => ({ ...prev, publisher: false }));
        }
      }
      if (
        filterRef_visible_to_user.current &&
        !filterRef_visible_to_user.current.contains(event.target)
      ) {
        {
          const hasCategory = updateChipData.some(
            (chipItem) => chipItem.type === "visible_to_user"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData.filter(
              (chipItem) => chipItem.type === "visible_to_user"
            );
            setVisible_to_user(updatedCategory);
          } else {
            setVisible_to_user([]);
          }
          setIsOpen((prev) => ({ ...prev, visible_to_user: false }));
        }
      }
      if (
        filterRef_category.current &&
        !filterRef_category.current.contains(event.target)
      ) {
        {
          const hasCategory = updateChipData.some(
            (chipItem) => chipItem.type === "category"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData.filter(
              (chipItem) => chipItem.type === "category"
            );
            setCategory_on(updatedCategory);
          } else {
            setCategory_on([]);
          }
          setIsOpen((prev) => ({ ...prev, category: false }));
        }
      }
      if (
        filterRef_course.current &&
        !filterRef_course.current.contains(event.target)
      ) {
        {
          const hasCategory = updateChipData.some(
            (chipItem) => chipItem.type === "course"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData.filter(
              (chipItem) => chipItem.type === "course"
            );
            setCourse_on(updatedCategory);
          } else {
            setCourse_on([]);
          }
          setIsOpen((prev) => ({ ...prev, course: false }));
        }
      }
      if (
        filterRef_subject.current &&
        !filterRef_subject.current.contains(event.target)
      ) {
        {
          const hasCategory = updateChipData.some(
            (chipItem) => chipItem.type === "subject"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData.filter(
              (chipItem) => chipItem.type === "subject"
            );
            setSubject_on(updatedCategory);
          } else {
            setSubject_on([]);
          }
          setIsOpen((prev) => ({ ...prev, subject: false }));
        }
      }
      if (
        filterRef_medium.current &&
        !filterRef_medium.current.contains(event.target)
      ) {
        {
          const hasCategory = updateChipData.some(
            (chipItem) => chipItem.type === "medium"
          );
          if (hasCategory) {
            const updatedCategory = updateChipData.filter(
              (chipItem) => chipItem.type === "medium"
            );
            setMedium_on(updatedCategory);
          } else {
            setMedium_on([]);
          }
          setIsOpen((prev) => ({ ...prev, medium: false }));
        }
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [
    updateChipData,
    author_name,
    publisher_name,
    visible_to_user,
    category_on,
    course_on,
    subject_on,
    medium_on,
    initialfields,
  ]);
  const filters = useSelector((state) => state.listBookFilter);
  const [isFiltersInitialized, setIsFiltersInitialized] = useState(false);




  useEffect(() => {
    if (filauthor && filauthor.length > 0) {
      setAuthor_name(filauthor);
      filterAuthor = filauthor;
    } else {
      setAuthor_name(author_name);
      filterAuthor = author_name;
    }
    if (filpublisher && filpublisher.length > 0) {
      setPublisher_name(filpublisher);
      filterPublisher = filpublisher;
    } else {
      setPublisher_name(publisher_name);
      filterPublisher = publisher_name;
    }
    if (filvisibleToUser && filvisibleToUser.length > 0) {
      setVisible_to_user(filvisibleToUser);
      filtervisible_to_user = filvisibleToUser;
    } else {
      setVisible_to_user(visible_to_user);
      filtervisible_to_user = visible_to_user;
    }
    if (filcategory && filcategory.length > 0) {
      setCategory_on(filcategory);
      filterCategory = filcategory;
    } else {
      setCategory_on(category_on);
      filterCategory = category_on;
    }
    if (filcourse && filcourse.length > 0) {
      setCourse_on(filcourse);
      filterCourse = filcourse;
    } else {
      setCourse_on(course_on);
      filterCourse = course_on;
    }
    if (filsubject && filsubject.length > 0) {
      setSubject_on(filsubject);
      filterSubject = filsubject;
    } else {
      setSubject_on(subject_on);
      filterSubject = subject_on;
    } if (filmedium && filmedium.length > 0) {
      setMedium_on(filmedium);
      filterMedium = filmedium;
    } else {
      setMedium_on(medium_on);
      filterMedium = medium_on;
    }


    setIsFiltersInitialized(true);
    loadChipdata();
  }, []);



  useEffect(() => {
    if (LABEL === "Back to Books" || REDUXKEY !== 1) return;

    setAuthor_name(filters.author || []);
    setPublisher_name(filters.publisher || []);
    setVisible_to_user(filters.visibleToUser || []);
    setCategory_on(filters.category || []);
    setCourse_on(filters.course || []);
    setSubject_on(filters.subject || []);
    setMedium_on(filters.medium || []);
    setInitialfields(filters.price || {});
    setIsFiltersInitialized(true); // Mark filters as initialized

    const allFilters = [
      ...(filters.author || []),
      ...(filters.publisher || []),
      ...(filters.visibleToUser || []),
      ...(filters.category || []),
      ...(filters.course || []),
      ...(filters.subject || []),
      ...(filters.medium || []),
      ...(filters.price?.fromDate && filters.price?.toDate
        ? [
          {
            name: `${filters.price.fromDate} - ${filters.price.toDate}`,
            type: "price",
          },
        ]
        : []),
    ];
    setUpdateChipData(allFilters);
  }, [LABEL]);

  useEffect(() => {
    if (
      REDUXKEY != 1 &&
      isFiltersInitialized &&
      filters &&
      Object.keys(filters).some((key) => filters[key]?.length > 0)
    ) {
      loadListdata();
    }
  }, [JSON.stringify(filters), isFiltersInitialized, updateChipData]);
  useEffect(() => {
    if (REDUXKEY == 1 || isFiltersInitialized && filters) {
      loadListdata();
    }
  }, [REDUXKEY, JSON.stringify(filters), isFiltersInitialized, updateChipData]);
  useEffect(() => {
    filterAuthor = author_name;
  }, [author_name]);

  useEffect(() => {
    filterPublisher = publisher_name;
  }, [publisher_name]);

  useEffect(() => {
    filterCategory = category_on;
  }, [category_on]);

  useEffect(() => {
    filterCourse = course_on;
  }, [course_on]);
  useEffect(() => {
    filterSubject = subject_on;
  }, [subject_on]);
  useEffect(() => {
    filterMedium = medium_on;
  }, [medium_on]);

  useEffect(() => {
    filterAvalible_to_user = visible_to_user;
  }, [visible_to_user]);

  useEffect(() => {
    loadListdata();
  }, [updateChipData]);

  useEffect(() => {
    AxiosInstance.get("api/course/category_list")
      .then((res) => {
        if (res.status === 200 && Array.isArray(res.data.data)) {
          setCategoryId(res.data.data);
        } else {
          setCategoryId([]);
        }
      })
      .catch((error) => {
        return error;
      });
  }, []);

  // total table data  with pages

  const totalPages = Math.ceil(updateListData?.length / rowsPerPage);

  // prev button pagination
  const handlePrev = (val) => {
    setCurrentPage(val);
  };
  // next button pagination
  const handleNext = (val) => {
    setCurrentPage(val);
  };

  const handlePageCount = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
    setUpdateListData([]);
    // loadListdata();
  };
  // pagination start end -   item per page changing
  const start = (currentPage - 1) * rowsPerPage;
  const end = start + rowsPerPage;
  // const currentData = csvListData.slice(start, end);

  const currentData = updateListData?.slice(start, end);

  const handleSearchFocus = () => {
    if (txtBSearch.current) {
      txtBSearch.current.focus();

      // Create a new KeyboardEvent
      const event = new KeyboardEvent("keydown", {
        key: "Enter",
        keyCode: 13,
        which: 13,
        code: "Enter",
        bubbles: true,
      });

      // Dispatch the event
      txtBSearch.current.dispatchEvent(event);
    }
  };

  const handleFilterCourseSearch = (event, names) => {
    if (names == "course") {
      const searchInput = event.target.value;
      if (searchInput !== "") {
        const matchingObjects = courseId.filter(
          (item) =>
            item.course_name &&
            item.course_name.toLowerCase().includes(searchInput.toLowerCase())
        );
        // Do something with the matchingObjects, such as updating state or displaying them in the UI
        setCourseIds(matchingObjects);
      } else {
        setCourseIds(courseId);
      }
    } else if (names == "subject") {
      const searchInput = event.target.value;
      if (searchInput !== "") {
        const matchingObjects = subjectId.filter(
          (item) =>
            item.subject_name &&
            item.subject_name.toLowerCase().includes(searchInput.toLowerCase())
        );
        // Do something with the matchingObjects, such as updating state or displaying them in the UI
        setSubjectIds(matchingObjects);
      } else {
        setSubjectIds(subjectId);
      }
    }
  };

  const handleFilterSearchFocus = (name) => {
    if (name == "course") {
      if (txtBSearch_course.current) {
        txtBSearch_course.current.focus();
        // Create a new KeyboardEvent
        const event = new KeyboardEvent("keydown", {
          key: "Enter",
          keyCode: 13,
          which: 13,
          code: "Enter",
          bubbles: true,
        });
        // Dispatch the event
        txtBSearch_course.current.dispatchEvent(event);
      }
    } else if (name == "subject") {
      if (txtBSearch_sub.current) {
        txtBSearch_sub.current.focus();
        // Create a new KeyboardEvent
        const event = new KeyboardEvent("keydown", {
          key: "Enter",
          keyCode: 13,
          which: 13,
          code: "Enter",
          bubbles: true,
        });
        // Dispatch the event
        txtBSearch_sub.current.dispatchEvent(event);
      }
    }
  };

  const handleSort = (event, sortKey) => {
    event.preventDefault();
    let order = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(order);
    let sortedList = updateListData.sort((a, b) => {
      if (a[sortKey] < b[sortKey]) {
        return order === "asc" ? -1 : 1;
      }
      if (a[sortKey] > b[sortKey]) {
        return order === "asc" ? 1 : -1;
      }
      if (a[sortKey] == b[sortKey]) {
        return order === "asc" ? 1 : -1;
      }
      return 0;
    });
    setUpdateListData(sortedList);
    setSortColumn(sortKey);
  };

  const handleCheckboxChange = (event, names, typename) => {
    const { value, checked, name } = event.target;
    if (typename === "category") {
      if (checked) {
        setCategory_on([{ id: value, name: name, type: "category" }]);
      } else {
        setCategory_on(category_on.filter((item) => item.id !== value));
      }
    } else if (typename === "author") {
      if (checked) {
        setAuthor_name([{ id: value, name: name, type: "author" }]);
      } else {
        setAuthor_name(author_name.filter((item) => item.id !== value));
      }
    } else if (typename === "publisher") {
      if (checked) {
        setPublisher_name([{ id: value, name: name, type: "publisher" }]);
      } else {
        setPublisher_name(publisher_name.filter((item) => item.id !== value));
      }
    } else if (typename === "course") {
      if (checked) {
        setCourse_on([{ id: value, name: name, type: "course" }]);
      } else {
        setCourse_on(course_on.filter((item) => item.id !== value));
      }
    } else if (typename === "subject") {
      if (checked) {
        setSubject_on([{ id: value, name: name, type: "subject" }]);
      } else {
        setSubject_on(subject_on.filter((item) => item.id !== value));
      }
    } else if (typename === "medium") {
      if (checked) {
        setMedium_on([{ id: value, name: name, type: "medium" }]);
      } else {
        setMedium_on(medium_on.filter((item) => item.id !== value));
      }
    } else if (typename === "visible_to_user") {
      if (checked) {
        setVisible_to_user([
          { id: value, name: name, type: "visible_to_user" },
        ]);
      } else {
        setVisible_to_user(visible_to_user.filter((item) => item.id !== value));
      }
    }
  };

  // function loadListdata() {
  // let tempAuthor = [];
  // let tempPublisher = [];
  // let tempVisibleUser = [];
  // author_name.map((obj) => {
  //   tempAuthor.push(obj.id);
  // });
  // publisher_name.map((obj) => {
  //   tempPublisher.push(obj.id);
  // });
  // visible_to_user.map((obj) => {
  //   tempVisibleUser.push(obj.id);
  // });
  // let statusFilter = {
  //   author_name: author_name.length > 0 ? parseInt(tempAuthor[0]) : "",
  //   publisher_name: publisher_name.length > 0 ? parseInt(tempPublisher[0]) : "",
  //   search: searchTerm.length > 0 ? searchTerm : "",
  // };
  // setIsLoading(true);
  // AxiosInstance.post("/api/course/courselist", statusFilter)
  //   .then((res) => {
  //     if (res.data.status) {
  //       setIsLoading(false);
  //       const fiata = res.data.data;
  //       const serialNumberAddedData = fiata.map((data, index) => ({
  //         ...data,
  //         serialNumber: index + 1,
  //       }));
  //       setOriginalListData(serialNumberAddedData);
  //       setUpdateListData(serialNumberAddedData);
  //     } else if (res.data.status === false) {
  //       setUpdateListData([]);
  //       setIsLoading(false);
  //     }
  //   })
  //   .catch((error) => {
  //     setUpdateListData([]);
  //     setIsLoading(false);
  //     return error;
  //   });
  // }

  function loadListdata() {
    let tempAuthor = [];
    let tempPublisher = [];
    let tempCate = [];
    let tempSubj = [];
    let tempCourse = [];
    let tempMedium = [];
    let tempVuser = [];
    // Convert string IDs to numbers using parseInt or unary plus
    author_name.map((obj) => {
      tempAuthor.push(Number(obj.id));
    });
    publisher_name.map((obj) => {
      tempPublisher.push(Number(obj.id));
    });
    category_on.map((obj) => {
      tempCate.push(Number(obj.id));
    });
    course_on.map((obj) => {
      tempCourse.push(Number(obj.id));
    });
    subject_on.map((obj) => {
      tempSubj.push(Number(obj.id));
    });
    medium_on.map((obj) => {
      tempMedium.push(Number(obj.id));
    });
    visible_to_user.map((obj) => {
      tempVuser.push(Number(obj.id));
    });
    let statusFilter = {
      id: parseInt(ID),
      author_id: author_name.length > 0 ? tempAuthor : "",
      publisher_id: publisher_name.length > 0 ? tempPublisher : "",
      category_id: category_on.length > 0 ? tempCate : "",
      group_course_id: course_on.length > 0 ? tempCourse : "",
      subject_id: subject_on.length > 0 ? tempSubj : "",
      medium: medium_on.length > 0 ? tempMedium : "",
      visible_user: visible_to_user.length > 0 ? tempVuser : "",
      is_set: 0,
      start_range_mrp: initialfields.fromDate || "",
      end_range_mrp: initialfields.toDate || "",
    };
    setIsLoading(true);
    AxiosInstance.post("api/book/findById", statusFilter)
      .then((res) => {
        const setBookData = res.data.set_book;

        // Check if setBookData is an array
        if (Array.isArray(setBookData)) {
          const serialNumberAddedData = setBookData.map((data, index) => ({
            ...data,
            serialNumber: index + 1,
          }));
          setUpdateListData(serialNumberAddedData);
          getAPCSData(serialNumberAddedData);
        } else if (setBookData && setBookData.status === false) {
          setIsLoading(false);
          setUpdateListData([]);
        }
        if (res.data.status) {
          const HDF = res.data.data;
          setDataView(HDF);
          setRatingView(res.data.ratings_reviews);
          setIsLoading(false);
        } else {
          setIsLoading(false);
          setDataView({});
          setUpdateListData([]);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        return error;
      });
  }

  function getAPCSData(data) {
    if (data.length > 0) {
      const seenAuthorIds = new Set();
      const seenPublisherIds = new Set();
      const seenCourseIds = new Set();
      const seenSubjectIds = new Set();
      const auDatas = data
        .filter((es) => {
          if (seenAuthorIds.has(es.author_id)) {
            return false; // Skip this entry if the author_id is already seen
          } else {
            seenAuthorIds.add(es.author_id);
            return true; // Keep the entry
          }
        })
        .map((es) => ({
          author_name: es.author,
          author_id: es.author_id,
        }));

      setAuData(auDatas);
      const PublishDatas = data
        .filter((es) => {
          if (seenPublisherIds.has(es.publisher_id)) {
            return false;
          } else {
            seenPublisherIds.add(es.publisher_id);
            return true;
          }
        })
        .map((es) => ({
          publisher_name: es.publisher,
          publisher_id: es.publisher_id,
        }));

      setPubData(PublishDatas);

      const filteredPubData = PublishDatas.filter(
        (item) => item.publisher_id && item.publisher_id !== 0
      );
      const uniquePublishers = Array.from(
        new Map(
          filteredPubData.map((item) => [item.publisher_id, item])
        ).values()
      );
      setOriginalListDataPub(uniquePublishers);
      const CourseDatas = data
        .filter((es) => {
          if (seenCourseIds.has(es.group_course_id)) {
            return false; // Skip this entry if the publisher_id is already seen
          } else {
            seenCourseIds.add(es.group_course_id);
            return true; // Keep the entry
          }
        })
        .map((es) => ({
          course_name: es.group_course_name,
          course_id: es.group_course_id,
        }));

      setCourseId(CourseDatas);
      setCourseIds(CourseDatas);
      const SubjectDatas = data
        .filter((es) => {
          if (seenSubjectIds.has(es.subject_id)) {
            return false; // Skip this entry if the publisher_id is already seen
          } else {
            seenSubjectIds.add(es.subject_id);
            return true; // Keep the entry
          }
        })
        .map((es) => ({
          subject_name: es.subject_name,
          subject_id: es.subject_id,
        }));

      setSubjectId(SubjectDatas);
      setSubjectIds(SubjectDatas);
    }
  }

  function loadChipdata() {
    let tempArr = [];

    if (initialfields.fromDate || initialfields.toDate) {
      tempArr.push({
        name: ` ${initialfields.fromDate || 0} - ${initialfields.toDate || 0}`,
        value: `MRP`,
        type: "price",
      });
    }
    filterAuthor.map((obj) => {
      tempArr.push(obj);
    });
    filtervisible_to_user.map((obj) => {
      tempArr.push(obj);
    });
    filterPublisher.map((obj) => {
      tempArr.push(obj);
    });
    filterCategory.map((obj) => {
      tempArr.push(obj);
    });
    filterCourse.map((obj) => {
      tempArr.push(obj);
    });
    filterSubject.map((obj) => {
      tempArr.push(obj);
    });
    filterMedium.map((obj) => {
      tempArr.push(obj);
    });
    setUpdateChipData(tempArr);
  }

  function updateStateData() {
    filterAuthor = author_name;
    filterPublisher = publisher_name;
    filtervisible_to_user = visible_to_user;
    filterCategory = category_on;
    filterCourse = course_on;
    filterSubject = subject_on;
    filterMedium = medium_on;
  }

  const handleApplyFilter = (name, event) => {
    updateStateData();
    setTimeout(() => {
      loadChipdata();
    }, 100);
    if (name === "author") {
      setIsOpen({
        ...isOpen,
        author: false,
      });
    } else if (name === "publisher") {
      setIsOpen({
        ...isOpen,
        publisher: false,
      });
    } else if (name === "visible_to_user") {
      setIsOpen({
        ...isOpen,
        visible_to_user: false,
      });
    } else if (name === "category") {
      setIsOpen({
        ...isOpen,
        category: false,
      });
    } else if (name === "course") {
      setIsOpen({
        ...isOpen,
        course: false,
      });
    } else if (name === "subject") {
      setIsOpen({
        ...isOpen,
        subject: false,
      });
    } else if (name === "medium") {
      setIsOpen({
        ...isOpen,
        medium: false,
      });
    } else if (name === "price") {
      // let tempArr = [];
      // if (initialfields.fromDate || initialfields.toDate) {
      //   tempArr.push({
      //     name: `${initialfields.fromDate || 0} - ${initialfields.toDate || 0}`,
      //     value: `MRP`,
      //     type: "price"
      //   });
      // }
      // setUpdateChipData(tempArr); loadListdata();
      setIsOpen({
        ...isOpen,
        price: false,
      });
    }
  };

  const handleClear = (name) => {
    const updatedChips = updateChipData.filter((item) => item.type !== name);
    setUpdateChipData(updatedChips);
    setIsOpen({
      category: false,
      course: false,
      subject: false,
      medium: false,
      author: false,
      publisher: false,
      visible_to_user: false,
    });
    if (name === "author") {
      setAuthor_name([]);
      filterAuthor = [];
    } else if (name === "publisher") {
      setPublisher_name([]);
      filterPublisher = [];
    } else if (name === "visible_to_user") {
      setVisible_to_user([]);
      filtervisible_to_user = [];
    } else if (name === "category") {
      setCategory_on([]);
      filterCategory = [];
    } else if (name === "course") {
      setCourse_on([]);
      filterCourse = [];
    } else if (name === "subject") {
      setSubject_on([]);
      filterSubject = [];
    } else if (name === "medium") {
      setMedium_on([]);
      filterMedium = [];
    } else if (name === "price") {
      setInitialfields({});
      setIsOpen({
        ...isOpen,
        price: false,
      });
    }
  };

  const handleAllClear = () => {
    setAuthor_name([]);
    setPublisher_name([]);
    setVisible_to_user([]);
    setInitialfields({});
    setSubject_on([]);
    setMedium_on([]);
    setCourse_on([]);
    setCategory_on([]);
    setUpdateChipData([]);
  };

  const handleView = (id) => {
    // dispatch(
    //   setBookFilters({
    //     author: author_name,
    //     publisher: publisher_name,
    //     visibleToUser: visible_to_user,
    //     category: category_on,
    //     course: course_on,
    //     subject: subject_on,
    //     medium: medium_on,
    //     price: initialfields,
    //   })
    // );
    navigate(`/viewIndividualBook/${id}`, {
      state: {
        LABEL: "Back to View Bookset",
        AUTHOR: author_name,
        PUBLISHER: publisher_name,
        VISIBLETOUSER: visible_to_user,
        CATEGORY: category_on,
        COURSE: course_on,
        SUBJECT: subject_on,
        MEDIUM: medium_on,
        PRICE: initialfields,
        BOOKIDS: bookID,
        IDS: ID
      },
    });
  };

  const handleFilter = (e, boxName) => {
    if (boxName === "author") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        author: !prevState.author, // Toggle the value
        visible_to_user: false,
        publisher: false,
        category: false,
        course: false,
        subject: false,
        medium: false,
      }));
      setAuthor_name(updateChipData.filter((ui) => ui.type === "author"));
    } else if (boxName === "publisher") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        visible_to_user: false,
        publisher: !prevState.publisher, // Toggle the value
        category: false,
        course: false,
        subject: false,
        medium: false,
        author: false,
      }));
      setPublisher_name(updateChipData.filter((ui) => ui.type === "publisher"));
    } else if (boxName === "visible_to_user") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        visible_to_user: !prevState.visible_to_user, // Toggle the value
        publisher: false,
        category: false,
        course: false,
        subject: false,
        medium: false,
        author: false,
      }));
      setVisible_to_user(
        updateChipData.filter((ui) => ui.type === "visible_to_user")
      );
    } else if (boxName === "category") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        category: !prevState.category, // Toggle the value
        visible_to_user: false,
        publisher: false,
        course: false,
        subject: false,
        medium: false,
        author: false,
      }));
      setCategory_on(updateChipData.filter((ui) => ui.type === "category"));
    } else if (boxName === "course") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        course: !prevState.course, // Toggle the value
        category: false,
        visible_to_user: false,
        publisher: false,
        subject: false,
        medium: false,
        author: false,
      }));
      setCourse_on(updateChipData.filter((ui) => ui.type === "course"));
    } else if (boxName === "subject") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        subject: !prevState.subject, // Toggle the value
        course: false,
        category: false,
        visible_to_user: false,
        publisher: false,
        medium: false,
        author: false,
      }));
      setSubject_on(updateChipData.filter((ui) => ui.type === "subject"));
    } else if (boxName === "medium") {
      setIsOpen((prevState) => ({
        ...prevState, // Retain the current state values
        medium: !prevState.medium, // Toggle the value
        subject: false,
        course: false,
        category: false,
        visible_to_user: false,
        publisher: false,
        author: false,
      }));
      setMedium_on(updateChipData.filter((ui) => ui.type === "medium"));
    } else if (boxName === "price") {
      setIsOpen((prevState) => ({
        ...prevState,
        seriesTag: false,
        subject: false,
        course: false,
        category: false,
        is_visible: false,
        publisher: false,
        author: false,
        is_combo_offer: false,
        is_free_book: false,
        price: !prevState.price,
        availableToUser: false,
        medium: false,
      }));
    }
  };
  const handleDelete = (chipToDelete, index) => () => {
    updateStateData();
    let shouldReloadChipData = true;
    if (chipToDelete.type === "author") {
      setAuthor_name(author_name.filter((item) => item.id !== chipToDelete.id));
      filterAuthor = author_name.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "publisher") {
      setPublisher_name(
        publisher_name.filter((item) => item.id !== chipToDelete.id)
      );
      filterPublisher = publisher_name.filter(
        (item) => item.id !== chipToDelete.id
      );
    } else if (chipToDelete.type === "visible_to_user") {
      setVisible_to_user(
        visible_to_user.filter((item) => item.id !== chipToDelete.id)
      );
      filtervisible_to_user = visible_to_user.filter(
        (item) => item.id !== chipToDelete.id
      );
    } else if (chipToDelete.type === "category") {
      setCategory_on(category_on.filter((item) => item.id !== chipToDelete.id));
      filterCategory = category_on.filter(
        (item) => item.id !== chipToDelete.id
      );
    } else if (chipToDelete.type === "course") {
      setCourse_on(course_on.filter((item) => item.id !== chipToDelete.id));
      filterCourse = course_on.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "subject") {
      setSubject_on(subject_on.filter((item) => item.id !== chipToDelete.id));
      filterSubject = subject_on.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "medium") {
      setMedium_on(medium_on.filter((item) => item.id !== chipToDelete.id));
      filterMedium = medium_on.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "price") {
      setInitialfields({ fromDate: "", toDate: "" });
      setUpdateChipData((prevChips) =>
        prevChips.filter((chip) => chip.type !== "price")
      );
      shouldReloadChipData = false;
    }
    if (shouldReloadChipData) {
      loadChipdata();
    }
  };
  const handleEditBookSet = () => {
    dispatch(clearBookFilters());

    navigate(`/studyMaterials/Books/CreateBookSet/${ID}`);
  };

  useEffect(() => {
    setIsLoading(true);
    AxiosInstance.post("api/book/findById", { id: parseInt(ID) })
      .then((res) => {
        if (res.data.status === true) {
          setDataView({
            book_title: res.data.data.book_title,
            author: res.data.data.author,
            publisher: res.data.data.publisher,
            isbn_no: res.data.data.isbn_no,
            overall_ratings: res.data.data.overall_ratings,
            no_of_students: res.data.data.no_of_students,
            price: res.data.data.price,
            offer_percentage: res.data.data.offer_percentage,
            finalPrice: res.data.data.finalPrice,
            description: res.data.data.description,
            stock_count: res.data.data.stock_count,
            category_name: res.data.data.category_name,
            group_course_name: res.data.data.group_course_name,
            subject_name: res.data.data.subject_name,
            medium: res.data.data.medium,
            is_visible: res.data.data.is_visible,
            tags: res.data.data.tags,
            weight: res.data.data.weight,
            total_pages: res.data.data.total_pages,
            // iframe: res.data.data.iframe,
            iframe: res.data.data.iframe,
            dimension: res.data.data.dimension,
            ebook_url: res.data.data.ebook_url,
            preview_path: res.data.data.preview_path,
            original_preview_path: res.data.data.original_preview_path,
            images: res.data.data.images,
            tag_line: res.data.data.tag_line,
            is_free_book: res.data.data.is_free_book,
            is_combo_offer: res.data.data.is_combo_offer,
          });
          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        return error;
      });
  }, [ID]);
  const dispatch = useDispatch();
  const navigateToPreviousScreen = () => {
    dispatch(
      setFilters({
        items: ITEM,
        userEmail: USEREMAIL,
        freeSales: FREESALES,
        userNumber: USERNUMBER,
        fillCheckbox: CHECKBOX,
        fillSelectBooks: SELECTEDBOKS,
        filterBooksItems: BOOKITEMS,
      })
    );
    if (LABEL == "Back to View Pre-order") {
      navigate(`/studyMaterials/Books/ViewPreOrder/${BOOKIDS}/${IDS}`);
    } else if (LABEL == "Back to Create New Sales") {
      setBookFilters({
        activeTab: 1,

      })
      navigate(`/AddPurchase`)
    } else if (LABEL == "Back to View Sales") {
      navigate(`/ViewPurchase/${IDS}`)
    }


    else {
      navigate(`/studyMaterials/Books/List/2`)
    }

  };

  const getYouTubeID = (url) => {
    const regExp =
      /(?:youtube\.com\/(?:.*[?&]v=|v\/|embed\/|shorts\/)|youtu\.be\/)([^"&?\/\s]{11})/;
    const match = url.match(regExp);
    return match ? match[1] : "";
  };

  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <div className="BathHeader BathDet global_container">
      <div className="row mx-0">
        <div className="col-md-6 col-12 px-0">
          <h2 className="TitleHeader">View Bookset</h2>
        </div>
        <div className="col-md-6 col-12 ListBtn px-0">
          <ul class="List-Button">
            <li class="ListBtnItems">
              <Link
                to={"javascript:void(0)"}
                onClick={() => navigateToPreviousScreen()}
                className="secondaryButton "
                variant="secondary"
              >
                {/* {ID ? "Back To Create New Purchase" : "Back to Books"} */}
                {LABEL || "Back to Books"}
              </Link>
            </li>
            {LABEL == "Back to Books" && (
              <li className="ListBtnItems" onClick={handleEditBookSet}>
                <Link to={"javascript:void(0)"} className="primaryButton">
                  <span class="material-icons align-middle ">border_color</span>{" "}
                  Edit Bookset
                </Link>
              </li>
            )}
          </ul>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-xl-12 col-lg-12 col-md-12 col-12">
          <fieldset className={ViewBookSet.preorderContainer}>
            <legend className="w-auto mb-0">Bookset Details</legend>
            <div className="row mx-0 mb-2">
              <div className="px-0 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Bookset Name</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {dataView.book_title ? dataView.book_title : "_"}
                  </p>
                </div>
              </div>
              {/* tag_line */}
              <div className="px-0 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0"> Short Description</p>
                  <p className="confirm_value text-justify my-1 m-0 p-0">
                    {dataView.tag_line ? dataView.tag_line : "_"}
                  </p>
                </div>
              </div>
              {/* combo offer */}
              <div className="px-0 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">
                    Is this a combo offer?
                  </p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {dataView.is_combo_offer ? "Yes" : "No"}
                  </p>
                </div>
              </div>
              {/* free bookset */}
              <div className="px-0 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">
                    Is this a free book set?
                  </p>
                  <p className="confirm_value text-justify my-1 m-0 p-0">
                    {dataView.is_free_book ? "Yes" : "No"}
                  </p>
                </div>
              </div>
            </div>
            <div className="my-1 col-lg-3 col-md-3 col-12">
              <div className="d-flex flex-column">
                <p className="confirm_label m-0 p-0"> ISBN Number</p>
                <p className="confirm_value my-1 m-0 p-0">
                  {" "}
                  {dataView.isbn_no || "_"}
                </p>
              </div>
            </div>
            <div className="row mx-0">
              <div className="px-0  col-lg-12 col-md-12 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Detailed Description</p>
                  <p className="confirm_value text-justify my-1 m-0 p-0">
                    {/* In 'The Lost City of Aethel,' a young archaeologist, Maya,
                    stumbles upon an ancient map that leads her to a hidden,
                    mythical city in the Amazon rainforest, where she must
                    decipher cryptic clues and face perilous dangers to unlock
                    the secrets of a long-lost civilization, all while battling
                    against a rival team of treasure hunters determined to claim
                    the city for themselves. */}
                    {dataView.description ? dataView.description : "_"}
                  </p>
                </div>
              </div>
            </div>
          </fieldset>
          {/* youtube url */}
          {dataView?.iframe && (
            <fieldset className="mt-3">
              <legend className="w-auto">YouTube URL</legend>
              <div className="row">
                <div className="my-1 col-lg-12 col-md-12 col-12 text-center">
                  <iframe
                    src={`https://www.youtube.com/embed/${getYouTubeID(
                      dataView.iframe
                    )}`}
                    className={`${styles.iframeVideo}`}
                    allowFullScreen
                    title="Dynamic Iframe"
                  ></iframe>
                </div>
              </div>
            </fieldset>
          )}
        </div>
      </div>

      <div className="row mx-0 mt-3 mb-4">
        <div className="col-xl-12 col-lg-12 col-md-12 col-12 px-0">
          <fieldset className={ViewBookSet.preorderContainer}>
            <legend className="w-auto mb-0">Books in this Set</legend>
            {updateChipData?.length > 0 ? (
              <div className="row mt-3">
                <div className="col-md-12 col-sm-12 col-xs-12 paperil_global">
                  <Paper
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      flexWrap: "wrap",
                      listStyle: "none",
                      p: 0.5,
                      m: 0,
                    }}
                    component="ul"
                  >
                    {updateChipData.map((data, index) => {
                      let icon;
                      return (
                        <ListItem key={index}>
                          <Chip
                            icon={icon}
                            label={
                              <>
                                <span className={ViewBookSet.BoldTyText}>
                                  {data.type === "price"
                                    ? `Price: ${data.name}`
                                    : data.name}
                                </span>
                              </>
                            }
                            onDelete={handleDelete(data, index)}
                          />
                        </ListItem>
                      );
                    })}
                    <ListItem className="clearAll_list">
                      <a
                        className="clearAll_listItem"
                        href="javascript:void(0)"
                        onClick={handleAllClear}
                      >
                        Clear All Filters
                      </a>
                    </ListItem>
                  </Paper>
                </div>
              </div>
            ) : (
              <div></div>
            )}
            <div className="row mx-0 mt-2">
              <div
                className={`col-md-12 ${ViewBookSet.table_responsive_padding} table-responsive tableMinHeight px-0 `}
              >
                <table className="table" id="tableListHeader">
                  <thead>
                    <tr>
                      {/* s.No */}
                      <th id="th" className={ViewBookSet.tableThPadding}>
                        <span
                          onClick={(e) => handleSort(e, "serialNumber")}
                          className="textHead_th"
                        >
                          S.No.
                        </span>
                        <span
                          onClick={(e) => handleSort(e, "serialNumber")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export{" "}
                        </span>
                      </th>
                      {/* Book Name */}
                      <th id="th" className={ViewBookSet.tableThPadding}>
                        <span
                          onClick={(e) => handleSort(e, "book_title")}
                          className="textHead_th"
                        >
                          Book Name
                        </span>
                        <span
                          onClick={(e) => handleSort(e, "book_title")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export{" "}
                        </span>
                      </th>
                      {/* Author */}
                      <th id="th" className={ViewBookSet.tableThPadding}>
                        <span
                          onClick={(e) => handleSort(e, "author")}
                          className="textHead_th"
                        >
                          Author
                        </span>
                        <span
                          onClick={(e) => handleSort(e, "author")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export{" "}
                        </span>
                        <span
                          className={`textHead_th align-middle material-icons ${author_name.length > 0
                            ? ViewBookSet.active_icons_book
                            : ""
                            } ${isOpen.author ? ViewBookSet.active_icons_book : ""
                            }`} // Change here
                          onClick={(e) => handleFilter(e, "author")}
                        >
                          filter_list
                        </span>
                        {isOpen.author && (
                          <>
                            <div className="filterBoxs_testlist mt-4">
                              <div className="col-md-12 form-check filterStatus_list">
                                <ul className="ulFilterListData">
                                  {auData.map((el) => (
                                    <li className="filterListData">
                                      <input
                                        className="ListCheckbox"
                                        type="checkbox"
                                        name={el.author_name}
                                        value={el.author_id}
                                        id={el.author_name}
                                        checked={author_name.some((element) => {
                                          if (element.id == el.author_id) {
                                            return true;
                                          }
                                          return false;
                                        })}
                                        onChange={(e) =>
                                          handleCheckboxChange(
                                            e,
                                            el.author_name,
                                            "author"
                                          )
                                        }
                                      />
                                      <label
                                        className="form-check-label filterChipText_withoutBG "
                                        htmlFor={el.author_name}
                                      >
                                        {el.author_name}
                                      </label>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                              <div className="borderWidth row">
                                <ul className="List-Button">
                                  <li className="ListBtnItems">
                                    <Link
                                      to={"javascript:void(0)"}
                                      onClick={() => handleClear("author")}
                                      className="secondaryButton "
                                    >
                                      Clear
                                    </Link>
                                  </li>
                                  <li className="ListBtnItems">
                                    <Link
                                      disabled={
                                        author_name.length === 0 ? true : false
                                      }
                                      onClick={() =>
                                        handleApplyFilter("author")
                                      }
                                      className="primaryButton"
                                    >
                                      Apply Filter
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div
                              ref={filterRef_author}
                              className={`${ViewBookSet.overlayBookFilter} ${isOpen.author ? "active" : ""
                                }`}
                            ></div>
                          </>
                        )}
                      </th>
                      {/* Publisher */}
                      <th id="th" className={ViewBookSet.tableThPadding}>
                        <span
                          onClick={(e) => handleSort(e, "publisher")}
                          className="textHead_th"
                        >
                          Publisher
                        </span>
                        <span
                          onClick={(e) => handleSort(e, "publisher")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export{" "}
                        </span>
                        <span
                          className={`textHead_th align-middle material-icons ${publisher_name.length > 0
                            ? ViewBookSet.active_icons_book
                            : ""
                            } ${isOpen.publisher
                              ? ViewBookSet.active_icons_book
                              : ""
                            }`} // Change here
                          onClick={(e) => handleFilter(e, "publisher")}
                        >
                          filter_list
                        </span>
                        {isOpen.publisher && (
                          <>
                            <div className="filterBoxs_testlist mt-4">
                              <div className="col-md-12 form-check filterStatus_list">
                                <ul className="ulFilterListData">
                                  {originalListDataPub.map((el) => (
                                    <li className="filterListData">
                                      <input
                                        className="ListCheckbox"
                                        type="checkbox"
                                        name={el.publisher_name}
                                        value={el.publisher_id}
                                        id={el.publisher_name}
                                        checked={publisher_name.some(
                                          (element) => {
                                            if (element.id == el.publisher_id) {
                                              return true;
                                            }
                                            return false;
                                          }
                                        )}
                                        onChange={(e) =>
                                          handleCheckboxChange(
                                            e,
                                            el.publisher_name,
                                            "publisher"
                                          )
                                        }
                                      />
                                      <label
                                        className="form-check-label filterChipText_withoutBG "
                                        htmlFor={el.publisher_name}
                                      >
                                        {el.publisher_name}
                                      </label>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                              <div className="borderWidth row">
                                <ul className="List-Button">
                                  <li className="ListBtnItems">
                                    <Link
                                      to={"javascript:void(0)"}
                                      onClick={() => handleClear("publisher")}
                                      className="secondaryButton "
                                    >
                                      Clear
                                    </Link>
                                  </li>
                                  <li className="ListBtnItems">
                                    <Link
                                      disabled={
                                        publisher_name.length === 0
                                          ? true
                                          : false
                                      }
                                      onClick={() =>
                                        handleApplyFilter("publisher")
                                      }
                                      className="primaryButton"
                                    >
                                      Apply Filter
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div
                              ref={filterRef_publisher}
                              className={`${ViewBookSet.overlayBookFilter} ${isOpen.publisher ? "active" : ""
                                }`}
                            ></div>
                          </>
                        )}
                      </th>
                      {/* Visible to users */}
                      <th
                        id="th"
                        className={ViewBookSet.tableThPadding}
                        ref={filterRef_visible_to_user}
                      >
                        <div class={ViewBookSet.thcontent}>
                          <span
                            onClick={(e) => handleSort(e, "is_visible")}
                            className="textHead_th"
                          >
                            Visible <br /> to Users
                          </span>
                          <div class={ViewBookSet.iconcontainer}>
                            <span
                              onClick={(e) => handleSort(e, "is_visible")}
                              className={`textHead_th material-icons align-middle`}
                            >
                              import_export{" "}
                            </span>
                            <span
                              className={`textHead_th align-middle material-icons ${visible_to_user.length > 0
                                ? ViewBookSet.active_icons_book
                                : ""
                                } ${isOpen.visible_to_user
                                  ? ViewBookSet.active_icons_book
                                  : ""
                                }`} // Change here
                              onClick={(e) =>
                                handleFilter(e, "visible_to_user")
                              }
                            >
                              filter_list
                            </span>
                          </div>
                          {isOpen.visible_to_user && (
                            <>
                              <div className="filterBoxs_testlist mt-4">
                                <div className="col-md-12 form-check filterStatus_list">
                                  <ul className="ulFilterListData">
                                    <li className="filterListData">
                                      <input
                                        className="ListCheckbox"
                                        type="checkbox"
                                        name={"visible to user :Yes"}
                                        value={"1"}
                                        checked={visible_to_user.some(
                                          (element) => {
                                            if (element.id == "1") {
                                              return true;
                                            }
                                            return false;
                                          }
                                        )}
                                        id={"visible_to_user_yes"}
                                        onChange={(e) =>
                                          handleCheckboxChange(
                                            e,
                                            "visible_to_user",
                                            "visible_to_user"
                                          )
                                        }
                                      />
                                      <label
                                        className="form-check-label filterChipText_withoutBG "
                                        htmlFor={"visible_to_user_yes"}
                                      >
                                        Yes
                                      </label>
                                    </li>
                                    <li className="filterListData">
                                      <input
                                        className="ListCheckbox"
                                        type="checkbox"
                                        name={"visible to user :No "}
                                        value={"0"}
                                        checked={visible_to_user.some(
                                          (element) => {
                                            if (element.id == "0") {
                                              return true;
                                            }
                                            return false;
                                          }
                                        )}
                                        id={"visible_to_user_no"}
                                        onChange={(e) =>
                                          handleCheckboxChange(
                                            e,
                                            "visible_to_user",
                                            "visible_to_user"
                                          )
                                        }
                                      />
                                      <label
                                        className="form-check-label filterChipText_withoutBG "
                                        htmlFor={"visible_to_user_no"}
                                      >
                                        No
                                      </label>
                                    </li>
                                  </ul>
                                </div>
                                <div className="borderWidth row">
                                  <ul className="List-Button">
                                    <li className="ListBtnItems">
                                      <Link
                                        to={"javascript:void(0)"}
                                        onClick={() =>
                                          handleClear("visible_to_user")
                                        }
                                        className="secondaryButton "
                                      >
                                        Clear
                                      </Link>
                                    </li>
                                    <li className="ListBtnItems">
                                      <Link
                                        disabled={
                                          visible_to_user.length === 0
                                            ? true
                                            : false
                                        }
                                        onClick={() =>
                                          handleApplyFilter("visible_to_user")
                                        }
                                        className="primaryButton"
                                      >
                                        Apply Filter
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                              <div
                                ref={filterRef_avaliable_to_user}
                                className={`${ViewBookSet.overlayBookFilter} ${isOpen.visible_to_user ? "active" : ""
                                  }`}
                              ></div>
                            </>
                          )}
                        </div>
                      </th>
                      {/* Category */}
                      <th id="th" className={ViewBookSet.tableThPadding}>
                        <span
                          onClick={(e) => handleSort(e, "category_name")}
                          className="textHead_th"
                        >
                          Category
                        </span>
                        <span
                          onClick={(e) => handleSort(e, "category_name")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export{" "}
                        </span>
                        <span
                          className={`textHead_th align-middle material-icons ${category_on.length > 0
                            ? ViewBookSet.active_icons_book
                            : ""
                            } ${isOpen.category ? ViewBookSet.active_icons_book : ""
                            }`} // Change here
                          onClick={(e) => handleFilter(e, "category")}
                        >
                          filter_list
                        </span>

                        {isOpen.category && (
                          <>
                            <div className="filterBoxs_testlist mt-4">
                              <div className="col-md-12 form-check filterStatus_list">
                                <ul className="ulFilterListData">
                                  {categoryId.map((el) => (
                                    <li className="filterListData">
                                      <input
                                        className="ListCheckbox"
                                        type="checkbox"
                                        name={el.name}
                                        value={el.id}
                                        id={el.name}
                                        checked={category_on.some((element) => {
                                          if (element.name == el.name) {
                                            return true;
                                          }
                                          return false;
                                        })}
                                        onChange={(e) =>
                                          handleCheckboxChange(
                                            e,
                                            el.name,
                                            "category"
                                          )
                                        }
                                      />
                                      <label
                                        className="form-check-label filterChipText_withoutBG "
                                        htmlFor={el.name}
                                      >
                                        {el.name}
                                      </label>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                              <div className="borderWidth row">
                                <ul className="List-Button">
                                  <Link
                                    to={"javascript:void(0)"}
                                    onClick={() => handleClear("category")}
                                    className="secondaryButton "
                                  >
                                    Clear
                                  </Link>
                                  <li className="ListBtnItems">
                                    <Link
                                      disabled={
                                        category_on.length === 0 ? true : false
                                      }
                                      onClick={() =>
                                        handleApplyFilter("category")
                                      }
                                      className="primaryButton"
                                    >
                                      Apply Filter
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div
                              ref={filterRef_category}
                              className={`${ViewBookSet.overlay} ${isOpen.category ? "active" : ""
                                }`}
                            ></div>
                          </>
                        )}
                      </th>
                      {/* course */}
                      <th id="th" className={ViewBookSet.tableThPadding}>
                        <span
                          onClick={(e) => handleSort(e, "group_course_name")}
                          className="textHead_th"
                        >
                          Course
                        </span>
                        <span
                          onClick={(e) => handleSort(e, "group_course_name")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export{" "}
                        </span>
                        <span
                          className={`textHead_th align-middle material-icons ${course_on.length > 0
                            ? ViewBookSet.active_icons_book
                            : ""
                            } ${isOpen.course ? ViewBookSet.active_icons_book : ""
                            }`} // Change here
                          onClick={(e) => handleFilter(e, "course")}
                        >
                          filter_list
                        </span>
                        {isOpen.course && (
                          <>
                            <div className="filterBoxs_testlist mt-4">
                              <div className="col-md-12 form-check filterStatus_list">
                                <ul className="ulFilterListData">
                                  <li
                                    className={`filterListData ${ViewBookSet.searchInputSec}`}
                                  >
                                    <input
                                      className={`${ViewBookSet.searchInput} w-100`}
                                      type="text"
                                      placeholder="Search by course"
                                      name="search_book_title"
                                      onKeyDown={(e) =>
                                        handleFilterCourseSearch(e, "course")
                                      }
                                      ref={txtBSearch_course}
                                    />
                                    <Search
                                      onClick={(e) =>
                                        handleFilterSearchFocus("course")
                                      }
                                      className={`${ViewBookSet.ListsearchIcon}`}
                                    />
                                  </li>
                                  {courseIds.map((el) => (
                                    <li className="filterListData">
                                      <input
                                        className="ListCheckbox"
                                        type="checkbox"
                                        name={el.course_name}
                                        value={el.course_id}
                                        id={el.course_name}
                                        checked={course_on.some((element) => {
                                          if (element.id == el.course_id) {
                                            return true;
                                          }
                                          return false;
                                        })}
                                        onChange={(e) =>
                                          handleCheckboxChange(
                                            e,
                                            el.course_name,
                                            "course"
                                          )
                                        }
                                      />
                                      <label
                                        className="form-check-label filterChipText_withoutBG "
                                        htmlFor={el.course_name}
                                      >
                                        {el.course_name}
                                      </label>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                              <div className="borderWidth row">
                                <ul className="List-Button">
                                  <li className="ListBtnItems">
                                    <Link
                                      to={"javascript:void(0)"}
                                      onClick={() => handleClear("course")}
                                      className="secondaryButton "
                                    >
                                      Clear
                                    </Link>
                                  </li>
                                  <li className="ListBtnItems">
                                    <Link
                                      disabled={
                                        course_on.length === 0 ? true : false
                                      }
                                      onClick={() =>
                                        handleApplyFilter("course")
                                      }
                                      className="primaryButton"
                                    >
                                      Apply Filter
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div
                              ref={filterRef_course}
                              className={`${ViewBookSet.overlayBookFilter} ${isOpen.course ? "active" : ""
                                }`}
                            ></div>
                          </>
                        )}
                      </th>
                      {/* Subject */}
                      <th id="th" className={ViewBookSet.tableThPadding}>
                        <span
                          onClick={(e) => handleSort(e, "subject_name")}
                          className="textHead_th"
                        >
                          Subject
                        </span>
                        <span
                          onClick={(e) => handleSort(e, "subject_name")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export{" "}
                        </span>
                        <span
                          className={`textHead_th align-middle material-icons ${subject_on.length > 0
                            ? ViewBookSet.active_icons_book
                            : ""
                            } ${isOpen.subject ? ViewBookSet.active_icons_book : ""
                            }`} // Change here
                          onClick={(e) => handleFilter(e, "subject")}
                        >
                          filter_list
                        </span>
                        {isOpen.subject && (
                          <>
                            <div className="filterBoxs_testlist mt-4">
                              <div className="col-md-12 form-check filterStatus_list">
                                <ul className="ulFilterListData">
                                  <li
                                    className={`filterListData ${ViewBookSet.searchInputSec}`}
                                  >
                                    <input
                                      className={`${ViewBookSet.searchInput} w-100`}
                                      type="text"
                                      placeholder="Search by subject"
                                      name="search_book_title"
                                      onKeyDown={(e) =>
                                        handleFilterCourseSearch(e, "subject")
                                      }
                                      ref={txtBSearch_sub}
                                    />
                                    <Search
                                      onClick={() =>
                                        handleFilterSearchFocus("subject")
                                      }
                                      className={`${ViewBookSet.ListsearchIcon}`}
                                    />
                                  </li>
                                  {subjectIds.map((el) => (
                                    <li className="filterListData">
                                      <input
                                        className="ListCheckbox"
                                        type="checkbox"
                                        name={el.subject_name}
                                        value={el.subject_id}
                                        id={el.subject_name}
                                        checked={subject_on.some((element) => {
                                          if (element.id == el.subject_id) {
                                            return true;
                                          }
                                          return false;
                                        })}
                                        onChange={(e) =>
                                          handleCheckboxChange(
                                            e,
                                            el.subject_name,
                                            "subject"
                                          )
                                        }
                                      />
                                      <label
                                        className="form-check-label filterChipText_withoutBG "
                                        htmlFor={el.subject_name}
                                      >
                                        {el.subject_name}
                                      </label>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                              <div className="borderWidth row">
                                <ul className="List-Button">
                                  <li className="ListBtnItems">
                                    <Link
                                      to={"javascript:void(0)"}
                                      onClick={() => handleClear("subject")}
                                      className="secondaryButton "
                                    >
                                      Clear
                                    </Link>
                                  </li>
                                  <li className="ListBtnItems">
                                    <Link
                                      disabled={
                                        subject_on.length === 0 ? true : false
                                      }
                                      onClick={() =>
                                        handleApplyFilter("subject")
                                      }
                                      className="primaryButton"
                                    >
                                      Apply Filter
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div
                              ref={filterRef_subject}
                              className={`${ViewBookSet.overlayBookFilter} ${isOpen.subject ? "active" : ""
                                }`}
                            ></div>
                          </>
                        )}
                      </th>
                      {/* Medium */}
                      <th id="th" className={ViewBookSet.tableThPadding}>
                        <span
                          onClick={(e) => handleSort(e, "medium")}
                          className="textHead_th"
                        >
                          Medium
                        </span>
                        <span
                          onClick={(e) => handleSort(e, "medium")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export{" "}
                        </span>
                        <span
                          className={`textHead_th align-middle material-icons ${medium_on.length > 0
                            ? ViewBookSet.active_icons_book
                            : ""
                            } ${isOpen.medium ? ViewBookSet.active_icons_book : ""
                            }`} // Change here
                          onClick={(e) => handleFilter(e, "medium")}
                        >
                          filter_list
                        </span>
                        {isOpen.medium && (
                          <>
                            <div className="filterBoxs_testlist mt-5">
                              <div className="col-md-12 form-check filterStatus_list">
                                <ul className="ulFilterListData">
                                  <li className="filterListData">
                                    <input
                                      className="ListCheckbox"
                                      type="checkbox"
                                      name={"Tamil"}
                                      value={"0"}
                                      checked={medium_on.some((element) => {
                                        if (element.id == "0") {
                                          return true;
                                        }
                                        return false;
                                      })}
                                      id={"Tamil"}
                                      onChange={(e) =>
                                        handleCheckboxChange(
                                          e,
                                          "medium",
                                          "medium"
                                        )
                                      }
                                    />
                                    <label
                                      className="form-check-label filterChipText_withoutBG "
                                      htmlFor={"Tamil"}
                                    >
                                      Tamil
                                    </label>
                                  </li>
                                  <li className="filterListData">
                                    <input
                                      className="ListCheckbox"
                                      type="checkbox"
                                      name={"English"}
                                      value={"1"}
                                      checked={medium_on.some((element) => {
                                        if (element.id == "1") {
                                          return true;
                                        }
                                        return false;
                                      })}
                                      id={"English"}
                                      onChange={(e) =>
                                        handleCheckboxChange(
                                          e,
                                          "medium",
                                          "medium"
                                        )
                                      }
                                    />
                                    <label
                                      className="form-check-label filterChipText_withoutBG "
                                      htmlFor={"English"}
                                    >
                                      English
                                    </label>
                                  </li>

                                  <li className="filterListData">
                                    <input
                                      className="ListCheckbox"
                                      type="checkbox"
                                      name={"Both"}
                                      value={"2"}
                                      checked={medium_on.some((element) => {
                                        if (element.id == "2") {
                                          return true;
                                        }
                                        return false;
                                      })}
                                      id={"Both"}
                                      onChange={(e) =>
                                        handleCheckboxChange(
                                          e,
                                          "medium",
                                          "medium"
                                        )
                                      }
                                    />
                                    <label
                                      className="form-check-label filterChipText_withoutBG "
                                      htmlFor={"Both"}
                                    >
                                      Both
                                    </label>
                                  </li>
                                </ul>
                              </div>
                              <div className="borderWidth row">
                                <ul className="List-Button">
                                  <li className="ListBtnItems">
                                    <Link
                                      to={"javascript:void(0)"}
                                      onClick={() => handleClear("medium")}
                                      className="secondaryButton "
                                    >
                                      Clear
                                    </Link>
                                  </li>
                                  <li className="ListBtnItems">
                                    <Link
                                      disabled={
                                        medium_on.length === 0 ? true : false
                                      }
                                      onClick={() =>
                                        handleApplyFilter("medium")
                                      }
                                      className="primaryButton"
                                    >
                                      Apply Filter
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </>
                        )}
                      </th>
                      <th
                        id="th"
                        className={ViewBookSet.tableThPadding}
                        ref={filterRef_mrp}
                      >
                        <span
                          onClick={(e) => handleSort(e, "price")}
                          className="textHead_th"
                        >
                          MRP
                        </span>
                        <span
                          onClick={(e) => handleSort(e, "price")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export{" "}
                        </span>
                        <span
                          className={`textHead_th align-middle material-icons ${initialfields.fromDate ||
                            initialfields.toDate ||
                            isOpen.price
                            ? ViewBookSet.active_icons_book
                            : ""
                            } `} // Change here
                          onClick={(e) => handleFilter(e, "price")}
                        >
                          filter_list
                        </span>
                        {isOpen.price === true && (
                          <div className="filterBoxs p-1 mt-3">
                            <div className="row ">
                              <div className="col-md-12">
                                <div>
                                  <div>
                                    <label
                                      for="bookName"
                                      class="form-label confirm_value "
                                    >
                                      From
                                    </label>
                                  </div>
                                  <input
                                    class={`desc_input_text w-100 rounded-2 input-font-size-sm`} //new style added
                                    type="number"
                                    id="fromDate"
                                    name="fromDate"
                                    onWheel={(e) => e.target.blur()}
                                    placeholder="Enter the from price"
                                    value={initialfields.fromDate}
                                    onChange={handleChange}
                                  />
                                </div>
                                <div>
                                  <div>
                                    <label
                                      for="bookName"
                                      class="form-label confirm_value "
                                    >
                                      To
                                    </label>
                                  </div>
                                  <input
                                    class={`desc_input_text w-100 rounded-2 input-font-size-sm`} //new style added
                                    type="number"
                                    id="toDate"
                                    name="toDate"
                                    onWheel={(e) => e.target.blur()}
                                    placeholder="Enter the to price"
                                    value={initialfields.toDate}
                                    onChange={handleChange}
                                  />
                                </div>
                                {/* <div class="form-check">
                                                                      <MultiRangeSlider
                                                                        handleChangeFilter={handleChangeFilter}
                                                                        ranges={ranges}
                                                                      />
                                                                    </div> */}
                              </div>
                            </div>
                            <hr />
                            <div className="row mt-3">
                              <div className="col-md-4  col-4 col-sm-4">
                                <span
                                  className="clearFilter ms-2 "
                                  style={{ cursor: "pointer" }}
                                  onClick={() => handleClear("price")}
                                >
                                  Clear
                                </span>
                              </div>
                              <div className="col-md-8  col-8 col-sm-8">
                                <button
                                  className="FilterButton"
                                  onClick={() => handleApplyFilter("price")}
                                >
                                  Apply Filter
                                </button>
                              </div>
                            </div>
                          </div>
                        )}
                      </th>
                      {/* offer */}
                      <th id="th" className={ViewBookSet.tableThPadding}>
                        <span
                          onClick={(e) => handleSort(e, "offer_percentage")}
                          className="textHead_th"
                        >
                          Offer %
                        </span>
                        <span
                          onClick={(e) => handleSort(e, "offer_percentage")}
                          className={`textHead_th material-icons align-middle`}
                        >
                          import_export{" "}
                        </span>
                      </th>
                      {/* final price */}
                      <th id="th" className={ViewBookSet.tableThPadding}>
                        <div class={ViewBookSet.thcontent}>
                          <span
                            onClick={(e) => handleSort(e, "finalPrice")}
                            className="textHead_th"
                          >
                            Final
                            <br /> Price
                          </span>
                          <div class={ViewBookSet.iconcontainer}>
                            <span
                              onClick={(e) => handleSort(e, "finalPrice")}
                              className={`textHead_th material-icons align-middle`}
                            >
                              import_export{" "}
                            </span>
                          </div>
                        </div>
                      </th>{" "}
                      {/* stock count */}
                      <th id="th" className={ViewBookSet.tableThPadding}>
                        <div class={ViewBookSet.thcontent}>
                          <span
                            onClick={(e) => handleSort(e, "stock_count")}
                            className="textHead_th"
                          >
                            Stock
                            <br /> Count
                          </span>
                          <div class={ViewBookSet.iconcontainer}>
                            <span
                              onClick={(e) => handleSort(e, "stock_count")}
                              className={`textHead_th material-icons align-middle`}
                            >
                              import_export{" "}
                            </span>
                          </div>
                        </div>
                      </th>{" "}
                      {/* action */}
                      <th id="th" className={ViewBookSet.tableThPadding}>
                        <span className="textHead_th">Action</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentData?.length === 0 ? (
                      <tr>
                        <td colspan="15" style={{ textAlign: "center" }}>
                          No records to display
                        </td>
                      </tr>
                    ) : (
                      currentData?.map((kl, ind) => (
                        <tr
                          key={ind}
                          className={
                            kl.stock_count < 0 ? ViewBookSet.redRow : ""
                          }
                        >
                          <td id="td">{kl.serialNumber}</td>
                          <td id="td">
                            <span
                              title={kl.book_title}
                              className={ViewBookSet.ellipsisText}
                            >
                              {kl.book_title}
                            </span>
                          </td>
                          <td id="td">
                            {" "}
                            <span
                              title={kl.author}
                              className={ViewBookSet.ellipsisText}
                            >
                              {kl.author ? kl.author : "_"}
                            </span>
                          </td>
                          <td id="td">
                            <span
                              title={kl.publisher}
                              className={ViewBookSet.ellipsisText}
                            >
                              {kl.publisher ? kl.publisher : "_"}
                            </span>
                          </td>
                          <td id="td">{kl.is_visible ? "Yes" : "No"}</td>
                          <td id="td">
                            {kl.category_name ? kl.category_name : "_"}
                          </td>
                          <td id="td">
                            {kl.group_course_name ? kl.group_course_name : "_"}
                          </td>
                          <td id="td">
                            <span
                              title={kl.subject_name}
                              className={ViewBookSet.ellipsisText}
                            >
                              {kl.subject_name ? kl.subject_name : "_"}
                            </span>
                          </td>
                          <td id="td">{kl.medium ? kl.medium : "_"}</td>
                          <td id="td">{kl.price ? kl.price : "0"}</td>
                          <td id="td">
                            {kl.offer_percentage ? kl.offer_percentage : "0"}
                          </td>
                          <td id="td">{kl.finalPrice ? kl.finalPrice : "0"}</td>
                          <td id="td">
                            {kl.stock_count == 0
                              ? kl.stock_count
                              : kl.stock_count || "_"}
                          </td>
                          <td id="td">
                            <img
                              src={ViewIcon}
                              className={ViewBookSet.cursor_pointer}
                              alt="view icon"
                              onClick={(e) => handleView(kl.id)}
                            />
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="row mt-2">
              <Pagination
                rowsPerPage={rowsPerPage}
                handlePageCount={handlePageCount}
                startPage={
                  updateListData && updateListData?.length > 0
                    ? currentPage * rowsPerPage + 1 - rowsPerPage
                    : 0
                }
                endPage={
                  updateListData && updateListData?.length > 0
                    ? updateListData?.length < currentPage * rowsPerPage
                      ? updateListData?.length
                      : currentPage * rowsPerPage
                    : 0
                }
                totalRecords={
                  updateListData && updateListData?.length > 0
                    ? updateListData?.length
                    : 0
                }
                handlePrev={(e) => handlePrev(currentPage - 1)}
                currentPrevPage={currentPage === 1}
                prevButton={`${ViewBookSet.prev_buttonViewAllbook} ${ViewBookSet.materialIconsRightAndLeft} me-2`}
                handleNext={() => handleNext(currentPage + 1)}
                currentNextPage={currentPage === totalPages || totalPages == 0}
              />
            </div>
          </fieldset>
        </div>
      </div>
      {/* price portion */}
      <div className="row mt-3">
        <div className="col-xl-12 col-lg-12 col-md-12 col-12">
          <fieldset className={ViewBookSet.preorderContainer}>
            <legend className="w-auto mb-0">Price</legend>
            <div className="row mx-0 ">
              <div className="px-0 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">MRP</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {dataView.price ? dataView.price : "_"}
                  </p>
                </div>
              </div>
              <div className="px-0  col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Offer Percentage</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {dataView.offer_percentage
                      ? dataView.offer_percentage
                      : "0"}
                  </p>
                </div>
              </div>
              <div className="px-0  col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Final Price</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {dataView.finalPrice ? dataView.finalPrice : "0"}
                  </p>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
      {/* course Details */}
      <div className="row mt-3">
        <div className="col-xl-12 col-lg-12 col-md-12 col-12">
          <fieldset className={ViewBookSet.preorderContainer}>
            <legend className="w-auto mb-0">Course Details</legend>
            <div className="row mx-0 ">
              <div className="col-lg-3 col-md-3 col-12 padding-right-left-6">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Category</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {dataView.category_name ? dataView.category_name : "_"}
                  </p>
                </div>
              </div>
              <div className=" col-lg-4 col-md-4 col-12 padding-right-left-6">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Course</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {dataView.group_course_name
                      ? dataView.group_course_name
                      : "_"}
                  </p>
                </div>
              </div>
              <div className=" col-lg-3 col-md-3 col-12 padding-right-left-6">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Subject</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {dataView.subject_name ? dataView.subject_name : "_"}
                  </p>
                </div>
              </div>
              <div className=" col-lg-2 col-md-2 col-12 padding-right-left-6">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Medium</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {dataView.medium ? dataView.medium : "_"}
                  </p>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
      {/* Weight */}
      <div className="row mt-3">
        <div className="col-xl-12 col-lg-12 col-md-12 col-12">
          <fieldset className={ViewBookSet.preorderContainer}>
            <legend className="w-auto mb-0">Weight</legend>
            <div className="row mx-0 ">
              <div className="px-0 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Weight (in kg)</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {dataView.weight ? dataView.weight : "_"}
                  </p>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
      {/* tags */}
      <div className="row mt-3">
        <div className="col-xl-12 col-lg-12 col-md-12 col-12">
          <fieldset className={ViewBookSet.preorderContainer}>
            <legend className="w-auto mb-0">Tags</legend>
            <div className="row mx-0 ">
              <div className="px-0 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0">Tags</p>
                  <p className="confirm_value  m-0 p-0">
                    {" "}
                    <ul
                      className={` p-0 mt-2 d-flex flex-wrap ${styles.BookTagchip}`}
                    >
                      {dataView.tags?.length > 0 &&
                        dataView.tags.map((item) => {
                          return (
                            <li>
                              <a
                                href="javascript:void(0)"
                                className={styles.BookTagChipLabel}
                              >
                                {item.tag_name}
                              </a>
                            </li>
                          );
                        })}
                    </ul>
                  </p>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
      {/* uploaded images */}
      <fieldset className="mt-3 mb-4">
        <legend className="w-auto">Uploaded Images</legend>
        <div className="row mb-2 mt-2">
          {dataView?.images?.map((item) => {
            return (
              <div className={`col-md-3 `}>
                <div className={`${styles.cardCenterAlign}`}>
                  <img
                    src={`${ImageUrlPrefix}/${item.book_image_path}`}
                    alt="Book Image"
                    className={`${styles.bookImage}`}
                  />
                </div>
              </div>
            );
          })}
        </div>
      </fieldset>
      {ratingReview?.length > 0 && (
        <fieldset className="mt-3">
          <legend className="w-auto">Ratings and Reviews</legend>
          {ratingReview?.length > 0 &&
            ratingReview?.map((item) => {
              return (
                <>
                  <div className="mt-2">
                    <div className="ulFilterListData d-flex">
                      {dataView.overall_ratings && (
                        <div className="filterListData col-md-6">
                          <div
                            className={`${ViewBookSet.ratings_star_icon} mb-2 mb-md-0`}
                          >
                            <p className={`${ViewBookSet.rating_title} mb-0`}>
                              {dataView.overall_ratings}
                              <Star className={ViewBookSet.star_icon} />
                            </p>
                          </div>
                          <div className="text-center W-100">
                            <p
                              className={`mb-0 ${ViewBookSet.BookSubTitle} text-start`}
                            >
                              (based on {dataView.no_of_students} ratings and
                              reviews given by our students)
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="borderWidth  mt-2">
                    <div className="row">
                      <div className="col-md-12 ">
                        <div className="d-flex mt-2">
                          <div className="">
                            {item.profile_path ? (
                              <img
                                src={`${ImageUrlPrefix}/${item.profile_path}`}
                                alt="Book Image"
                                className={`${styles.userProfileImage}`}
                              />
                            ) : (
                              <img
                                src={avatarImg}
                                alt="Book Image"
                                className={`${styles.userProfileImage}`}
                              />
                            )}
                          </div>
                          <div className={`${styles.userProfileName} `}>
                            <p className={`${styles.reviewUserName} m-0`}>
                              {" "}
                              {item.username} {"  "}{" "}
                              {`(${moment(item.date).format("DD/MM/YYYY")})`}
                            </p>
                            <div className="mt-1">
                              <Rating
                                name="simple-controlled"
                                sx={{
                                  "& .MuiRating-iconFilled": {
                                    color: "#c0272d", // Set filled icon color
                                  },
                                  "& .MuiRating-iconHover": {
                                    color: "#c0272d", // Set hover color
                                  },
                                  margin: 0,
                                }}
                                value={item.rating} // Use the rating state to control the selected stars
                                readOnly // This will stop hover interactions
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <p className={`${styles.reviewUserComment} mt-2`}>
                          {/* {initialfields.address} */}
                          {item.review}
                        </p>
                      </div>
                    </div>
                  </div>
                </>
              );
            })}
          <div className="borderWidth  mt-2">
            <div className="row mt-2">
              <Pagination
                rowsPerPage={rowsPerPage}
                handlePageCount={handlePageCount}
                startPage={
                  updateListData && updateListData?.length > 0
                    ? currentPage * rowsPerPage + 1 - rowsPerPage
                    : 0
                }
                endPage={
                  updateListData && updateListData?.length > 0
                    ? updateListData?.length < currentPage * rowsPerPage
                      ? updateListData?.length
                      : currentPage * rowsPerPage
                    : 0
                }
                totalRecords={
                  updateListData && updateListData?.length > 0
                    ? updateListData?.length
                    : 0
                }
                handlePrev={(e) => handlePrev(currentPage - 1)}
                currentPrevPage={currentPage === 1}
                prevButton={`${ViewBookSet.prev_buttonViewAllbook} ${ViewBookSet.materialIconsRightAndLeft} me-2`}
                handleNext={() => handleNext(currentPage + 1)}
                currentNextPage={currentPage === totalPages || totalPages == 0}
              />
            </div>
          </div>
        </fieldset>
      )}
    </div>
  );
}
